export const TAGIT_LOCAL_STORAGE_ID_KEY = "tagitId";

// Runs before the TagIt SDK so its stored browser identifier is consistently
// represented as a clear local-storage identifier.
export const TAGIT_LOCAL_STORAGE_ID_MIGRATION_SCRIPT = `
  try {
    var tagItStorageKey = "${TAGIT_LOCAL_STORAGE_ID_KEY}";
    var tagItStoredIdentity = null;
    try {
      var tagItStoredValue = window.localStorage.getItem(tagItStorageKey);
      tagItStoredIdentity = tagItStoredValue ? JSON.parse(tagItStoredValue) : null;
    } catch (_) {}
    var tagItEntityId = typeof tagItStoredIdentity?.entityId === "string" && tagItStoredIdentity.entityId
      ? tagItStoredIdentity.entityId
      : "ls-" + (window.crypto?.randomUUID?.() || ("xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx").replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0;
          return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
        }));
    window.localStorage.setItem(tagItStorageKey, JSON.stringify({
      entityId: tagItEntityId,
      entityidType: "ls",
      entityidAlgo: "clear",
      entityidOwner: window.location.hostname
    }));
  } catch (_) {}
`;
